import { render } from "./AffiliatesList.vue?vue&type=template&id=2f11efa2&scoped=true"
import script from "./AffiliatesList.vue?vue&type=script&lang=js"
export * from "./AffiliatesList.vue?vue&type=script&lang=js"

import "./AffiliatesList.vue?vue&type=style&index=0&id=2f11efa2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f11efa2"]])

export default __exports__